import React from "react";
import "../PaymentSolutions.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiCreditCard,
    FiShield,
    FiZap,
    FiDatabase,
    FiTrendingUp,
    FiGlobe,
    FiCheckCircle,
    FiBarChart2,
    FiLock
} from "react-icons/fi";


const PaymentSolutions = () => {

    return (

        <>

            <Header />


            <div className="payment-page">


                {/*=====================================================
                    HERO
======================================================*/}


                <section className="payment-hero">

                    <div className="container">


                        <div className="payment-hero-content">


                            <span className="payment-tag">

                                PAYMENT SOLUTIONS

                            </span>


                            <h1>

                                Secure & Scalable
                                <span> Digital Payment Infrastructure</span>

                            </h1>


                            <p>

                                Saivari Fintech provides secure payment solutions
                                that help banks, businesses, fintech companies,
                                and financial institutions simplify transactions,
                                improve payment efficiency, and deliver seamless
                                digital payment experiences.

                            </p>



                            <div className="payment-buttons">


                                <a
                                    href="/contact"
                                    className="payment-primary-btn">

                                    Get Consultation

                                </a>


                                {/* <Link
                                    to="/services"
                                    className="payment-secondary-btn">

                                    Explore Services

                                </Link> */}


                            </div>


                        </div>


                    </div>

                </section>




                {/*=====================================================
                    BREADCRUMB
======================================================*/}


                <section className="payment-breadcrumb">

                    <div className="container">


                        <Link to="/">Home</Link>

                        <FiChevronRight />


                        <Link to="/solutions">
                            Solutions
                        </Link>

                        <FiChevronRight />


                        <span>
                            Payment Solutions
                        </span>


                    </div>

                </section>




                {/*=====================================================
                    OVERVIEW
======================================================*/}


                <section className="payment-overview">


                    <div className="container">


                        <div className="payment-grid">


                            <div className="payment-content">


                                <span className="section-tag">
                                    OVERVIEW
                                </span>


                                <h2>

                                    Modern Payment Technology
                                    <span> For Digital Businesses</span>

                                </h2>


                                <p>

                                    Our payment solutions enable organizations
                                    to process transactions securely, automate
                                    financial operations, and provide customers
                                    with fast and reliable payment experiences.

                                </p>


                                <p>

                                    From payment gateway integration and transaction
                                    monitoring to reconciliation and API connectivity,
                                    we deliver solutions designed for performance,
                                    security, and compliance.

                                </p>



                                <div className="payment-checks">


                                    <div>
                                        <FiCheckCircle />
                                        Secure Payment Processing
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Payment Gateway Integration
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Transaction Monitoring
                                    </div>


                                    <div>
                                        <FiCheckCircle />
                                        Automated Reconciliation
                                    </div>


                                </div>



                            </div>





                            <div className="payment-dashboard">


                                <div className="payment-card">

                                    <FiCreditCard />

                                    <h3>
                                        Digital Payments
                                    </h3>

                                    <span>
                                        Fast Transactions
                                    </span>

                                </div>


                                <div className="payment-card">

                                    <FiShield />

                                    <h3>
                                        Secure Processing
                                    </h3>

                                    <span>
                                        Fraud Protection
                                    </span>

                                </div>


                                <div className="payment-card">

                                    <FiDatabase />

                                    <h3>
                                        Data Management
                                    </h3>

                                    <span>
                                        Real-Time Insights
                                    </span>

                                </div>


                                <div className="payment-card">

                                    <FiZap />

                                    <h3>
                                        Automation
                                    </h3>

                                    <span>
                                        Smart Operations
                                    </span>

                                </div>



                            </div>


                        </div>


                    </div>

                </section>








                <section className="payment-capabilities">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                OUR CAPABILITIES
                            </span>


                            <h2>

                                Complete Payment
                                <span> Technology Services</span>

                            </h2>

                        </div>




                        <div className="payment-service-grid">


                            {
                                [
                                    ["💳", "Payment Gateway Integration",
                                        "Connect secure payment gateways with banking systems and digital platforms."],

                                    ["🔐", "Payment Security",
                                        "Protect transactions with secure authentication and fraud prevention."],

                                    ["⚡", "Instant Payments",
                                        "Enable fast and reliable digital transaction processing."],

                                    ["📊", "Transaction Analytics",
                                        "Monitor payment performance with real-time insights."],

                                    ["🔄", "Reconciliation Services",
                                        "Automate settlement and financial reconciliation processes."],

                                    ["🌐", "API Payment Integration",
                                        "Build seamless connectivity between payment platforms."]
                                ].map((item, index) => (


                                    <div className="payment-service-card" key={index}>


                                        <div className="payment-icon">

                                            {item[0]}

                                        </div>


                                        <h3>
                                            {item[1]}
                                        </h3>


                                        <p>
                                            {item[2]}
                                        </p>


                                    </div>


                                ))


                            }


                        </div>


                    </div>


                </section>









                <section className="payment-challenges">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                CHALLENGES WE SOLVE
                            </span>


                            <h2>

                                Making Payments
                                <span> Simple & Secure</span>

                            </h2>

                        </div>



                        <div className="challenge-grid">


                            <div>

                                <FiLock />

                                <h3>
                                    Security Risks
                                </h3>

                                <p>
                                    Advanced security practices to protect sensitive payment data.
                                </p>

                            </div>



                            <div>

                                <FiTrendingUp />

                                <h3>
                                    Operational Efficiency
                                </h3>

                                <p>
                                    Automate payment workflows and reduce manual processes.
                                </p>

                            </div>




                            <div>

                                <FiBarChart2 />

                                <h3>
                                    Payment Visibility
                                </h3>

                                <p>
                                    Real-time analytics and transaction monitoring.
                                </p>

                            </div>



                        </div>


                    </div>


                </section>










                <section className="payment-process">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                OUR PROCESS
                            </span>


                            <h2>

                                How We Deliver
                                <span> Payment Solutions</span>

                            </h2>


                        </div>



                        <div className="payment-process-grid">


                            {
                                [
                                    "Requirement Analysis",
                                    "Payment Architecture Design",
                                    "Integration Development",
                                    "Security Testing",
                                    "Deployment",
                                    "Continuous Support"

                                ].map((item, index) => (


                                    <div className="payment-process-card">


                                        <div>
                                            0{index + 1}
                                        </div>


                                        <h3>
                                            {item}
                                        </h3>


                                    </div>


                                ))

                            }


                        </div>



                    </div>


                </section>








                <section className="payment-benefits">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                BENEFITS
                            </span>


                            <h2>

                                Why Choose Our
                                <span> Payment Solutions</span>

                            </h2>


                        </div>



                        <div className="payment-benefit-grid">


                            <div>
                                <FiShield />
                                <h3>Secure Transactions</h3>
                                <p>Enterprise-grade payment security.</p>
                            </div>


                            <div>
                                <FiZap />
                                <h3>Faster Processing</h3>
                                <p>Improve transaction speed and efficiency.</p>
                            </div>


                            <div>
                                <FiGlobe />
                                <h3>Scalable Platform</h3>
                                <p>Solutions built for growing businesses.</p>
                            </div>


                            <div>
                                <FiTrendingUp />
                                <h3>Business Growth</h3>
                                <p>Better payment experiences for customers.</p>
                            </div>


                        </div>


                    </div>


                </section>



            </div>


            <Footer />

        </>

    )

}


export default PaymentSolutions;